import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function UpdateBanner() {
  const [text, setText] = useState('');

  useEffect(() => {
    axios.get('/api/settings/banner')
      .then((r) => setText(r.data.text || ''))
      .catch(() => {});
  }, []);

  if (!text) return null;

  return (
    <div className="bg-blue-600 text-white text-xs font-medium overflow-hidden whitespace-nowrap" style={{ height: '28px' }}>
      <div
        className="inline-block"
        style={{
          animation: 'bannerScroll 30s linear infinite',
          paddingLeft: '100%',
        }}
      >
        <span className="font-bold tracking-widest uppercase mr-4">Updates</span>
        <span className="mr-2">•••</span>
        {text}
        <span className="ml-16" />
      </div>
      <style>{`
        @keyframes bannerScroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-100%); }
        }
      `}</style>
    </div>
  );
}
